import * as React from 'react';
import { connect } from 'react-redux';
import * as uuid from 'uuid';
import NotifyHOC from '../../../../../HOC/Notifications';

import { getNewOption } from '../buildOptions';
import { IApplicationState } from '../../../../../reducers';
import MediaLibraryAddModal from '../../../../libraries/mediaLibrary/MediaLibraryAddModal';

import { MULTIMEDIA_TYPES, OPTION_TYPES } from '@nexxt/common/types';

import PopupCardText from './PopupCardText';
import { PopupCardImage } from '.';
import PopupCardImageText from './PopupCardImageText';
import { createNewRichTextObject } from '@nexxt/common/services/TextService';

export interface IPopupCardProps {
    question: any;
    cards: any[];
    currentCard: any;
    updatePopupCard: (
        data: Array<IOptionFields>,
        deletedOptionIDs?: number[]
    ) => void;
    setQuestion: (keyName: string, value: any) => void;
    questionError: any;
    selectedOptionType: string;
    openIndex: number;
    editEnabled: boolean;
}

export interface IOptionFields {
    title: string;
    questionTexts: any;
    mediaURL: string;
}

interface IPopupCardState {
    isMediaLibraryOpen: boolean;
    currentIndex: number;
}

class PopupCard extends React.Component<IPopupCardProps, IPopupCardState> {
    constructor(props) {
        super(props);
        this.state = {
            isMediaLibraryOpen: false,
            currentIndex: this.props.openIndex
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { openIndex, selectedOptionType } = this.props;
        if (nextProps.openIndex !== openIndex) {
            this.setState({ currentIndex: nextProps.openIndex });
        }
    }

    handleChange = (index, keyName, value) => {
        const optionFields = [...(this.props.cards || [])];
        let newOptionField;
        //TODO: if there is nothing on fields. Need to be changed
        if (optionFields.length == 0) {
            newOptionField = [{ [keyName]: value }];
        } else {
            newOptionField = optionFields.map((field, sindex) => {
                if (index !== sindex) return field;
                return { ...field, [keyName]: value };
            });
        }
        this.props.updatePopupCard(newOptionField);
    };

    handleRichText = (
        cIndex,
        keyName,
        value,
        language,
        index,
        type = MULTIMEDIA_TYPES.RICH_TEXT
    ) => {
        const optionField = [...(this.props.cards || [])];
        const currentCardsObject = this.props.cards[cIndex][keyName] || [];
        let uploadedValue = false;
        const newTextField = currentCardsObject.filter(
            (c) => c.language === language
        )[0] || {
            language,
            contents: [
                {
                    id: uuid.v4(),
                    richText: createNewRichTextObject(''),
                    type
                }
            ]
        };
        newTextField.contents[0].richText = value;
        const currentLanguage = currentCardsObject.map((c) => {
            if (c.language === language) {
                uploadedValue = true;
                return { ...c, contents: newTextField.contents };
            }
            return c;
        });
        let newOptionField;
        if (!uploadedValue) {
            newOptionField = optionField.map((field, sindex) => {
                if (cIndex !== sindex) return field;
                return {
                    ...field,
                    [keyName]: [...currentLanguage, newTextField]
                };
            });
            this.props.updatePopupCard(newOptionField);
            return;
        }

        newOptionField = optionField.map((field, sindex) => {
            if (cIndex !== sindex) return field;
            return { ...field, [keyName]: [...currentLanguage] };
        });
        this.props.updatePopupCard(newOptionField);
    };

    selectMedia = (index: number, selectedMedia: any) => {
        const optionFields = [...(this.props.cards || [])];
        const newOptionField = optionFields.map((field, sindex) => {
            if (index !== sindex) return field;
            return {
                ...field,
                mediaURL: selectedMedia.mediaURL,
                showImage: true
            };
        });
        this.props.updatePopupCard(newOptionField);
    };

    renderPopupCards = (selectedOptionType: string) => {
        const { currentIndex } = this.state;
        const { cards, currentCard } = this.props;
        switch (selectedOptionType) {
            case OPTION_TYPES.TEXT_ONLY:
                return (
                    <PopupCardText
                        question={this.props.question}
                        questionError={this.props.questionError}
                        currentCard={currentCard}
                        cards={this.props.cards}
                        setValue={this.handleChange}
                        setValueWithLanguage={this.handleRichText}
                        index={currentIndex - 1}
                        editEnabled={this.props.editEnabled}
                    />
                );
            case OPTION_TYPES.IMAGE_ONLY:
                return (
                    <PopupCardImage
                        key={currentIndex}
                        question={this.props.question}
                        questionError={this.props.questionError}
                        currentCard={currentCard}
                        cards={this.props.cards}
                        setValue={this.handleChange}
                        setValueWithLanguage={this.handleRichText}
                        selectMedia={this.selectMedia}
                        index={currentIndex - 1}
                        editEnabled={this.props.editEnabled}
                    />
                );
            case OPTION_TYPES.IMAGE_AND_TEXT:
                return (
                    <PopupCardImageText
                        question={this.props.question}
                        questionError={this.props.questionError}
                        currentCard={currentCard}
                        cards={this.props.cards}
                        setValue={this.handleChange}
                        setValueWithLanguage={this.handleRichText}
                        selectMedia={this.selectMedia}
                        index={currentIndex - 1}
                        editEnabled={this.props.editEnabled}
                    />
                );
        }
    };
    render() {
        return this.renderPopupCards(this.props.selectedOptionType);
    }
}

const mapStateToProps = (store: IApplicationState) => {
    const {
        projectReducer: { currentProject }
    } = store;
    return {
        currentProject
    };
};

const mapDispatchToProps = (dispatch) => ({});

export default NotifyHOC(
    connect(mapStateToProps, mapDispatchToProps)(PopupCard)
);
